// extracted by mini-css-extract-plugin
export default {"container":"document_form_checkbox_container__eICJK","input":"document_form_checkbox_input__KRAaf","tooltip":"document_form_checkbox_tooltip__e3pfW"};